import { BORDER_RADIUS, DiscordSvg, FONT_SIZES, FONT_WEIGHTS, Icon, MEDIA, SxType, TwitterSvg } from "@bridgesplit/ui";
import { AutoStoriesOutlined } from "@mui/icons-material";
import {
    DISCLAIMER_URL,
    TERMS_URL,
    PRIVACY_URL,
    TWITTER_URL,
    DISCORD_URL,
    LOOPSCALE_MARKETING_SITE,
    DOCS
} from "app/constants";

export const NAV_Z_INDEX = 100;
export const CARD_Z_INDEX = NAV_Z_INDEX - 1;

export const NAV_BREAKPOINT = MEDIA.LG;
export const MOBILE_PADDING = 2;
export const DESKTOP_PADDING = 4;

export const NAV_BUTTON_HEIGHT = 35;
export const NAV_ICON_BUTTON_SX: SxType = {
    width: NAV_BUTTON_HEIGHT + "px",
    height: NAV_BUTTON_HEIGHT + "px",
    borderRadius: BORDER_RADIUS,
    borderColor: (theme) => theme.palette.divider,
    svg: {
        fontSize: `${FONT_SIZES.body1}px !important`,
        color: "inherit",
        fontWeight: FONT_WEIGHTS.normal
    }
};

export const FOOTER_LEFT_LINKS: { label: string; link: string }[] = [
    { label: "Disclaimer", link: DISCLAIMER_URL },
    { label: "Terms", link: TERMS_URL },
    { label: "Privacy", link: PRIVACY_URL }
];

export const FOOTER_SOCIAL_LINKS: { icon: JSX.Element; label: string; link: string; showText?: boolean }[] = [
    { icon: <TwitterSvg />, label: "X", link: TWITTER_URL },
    { icon: <DiscordSvg />, label: "Discord", link: DISCORD_URL },
    { icon: <Icon type="globe" />, label: "Loopscale", link: LOOPSCALE_MARKETING_SITE },
    { icon: <AutoStoriesOutlined />, label: "Docs", link: DOCS.root, showText: true }
];
